import Head from "next/head";
import { useRouter } from "next/router";
import { Fragment } from "react";

import { getPageTypes } from "@config/cms";
import { localeCountry } from "@config/config";

import { initEmptySeoTemplate } from "./emptyTemplate";

const DEFAULT_DESCRIPTION =
  "Discover Eastern Europe by coaches. Safe buses with all comforts. See destinations and get bus tickets in Europe online!";

const HeadSeo = ({
  properties = {},
  seo = initEmptySeoTemplate,
  slugs = null,
  type = "",
}) => {
  const isShowDates = [getPageTypes().story, getPageTypes().news].includes(
    type,
  );
  const { asPath, locales, locale, defaultLocale } = useRouter();
  const { dateModified, datePublished } = properties;
  const { NEXT_PUBLIC_DOMAIN } = process.env;

  const isHome = asPath === "/";
  const hasSlugs = !!slugs;

  const generateSlugs = () => {
    const slugs = [];
    locales.forEach((locale) => {
      slugs.push([locale, `${NEXT_PUBLIC_DOMAIN}${asPath}`]);
    });
    return slugs;
  };

  const filterCurrentSlugs = () => {
    return Object.entries(slugs).filter(([, slug]) => Boolean(slug));
  };

  // const existingSlugs = hasSlugs ? filterCurrentSlugs() : generateSlugs();
  const existingSlugs = hasSlugs ? filterCurrentSlugs() : [];

  // NOTE: for old pages with 'value' prop
  // Object.keys(seo).forEach(key => {
  //   if (seo[key].hasOwnProperty('value')) {
  //     seo[key] = seo[key].value;
  //   }
  // });

  let getOgImageUrl = () => {
    let ogImage = "";

    if (seo?.thumbnail?.trim()) {
      ogImage = seo.thumbnail.includes("https://")
        ? seo.thumbnail
        : `${NEXT_PUBLIC_DOMAIN}${seo.thumbnail}`;
    } else {
      ogImage = `${NEXT_PUBLIC_DOMAIN}/static/images/default-thumbnail/thumbnail.jpg`;
    }

    return ogImage;
  };

  const isDefault = locale === defaultLocale;

  let ogUrl = `${NEXT_PUBLIC_DOMAIN}${isDefault ? `` : `/${locale}`}${isHome ? "/" : asPath}`;

  return (
    <Head>
      <title>{seo.title}</title>
      <meta
        name="description"
        content={seo.description || DEFAULT_DESCRIPTION}
      />
      <meta name="keywords" content={seo.pageKeywords} />
      <meta property="og:title" content={seo.socialTitle} />
      <meta property="og:type" content="article" />
      {existingSlugs.map(([l]) => (
        <Fragment key={l}>
          <meta
            property={l === locale ? "og:locale" : "og:locale:alternate"}
            content={localeCountry[l]}
          />
        </Fragment>
      ))}
      <meta property="og:url" content={ogUrl} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image" content={getOgImageUrl()} />
      <meta property="og:site_name" content="Luxexpress" />
      <meta property="og:description" content={seo.socialDescription} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="1200" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content={NEXT_PUBLIC_DOMAIN} />
      <meta name="twitter:image" content={getOgImageUrl()} />

      {/* // TODO: line below content prop need clarify */}
      <meta name="twitter:creator" content="Luxexpress" />

      {isShowDates && datePublished && (
        <meta name="article:published_time" content={datePublished} />
      )}
      {isShowDates && dateModified && (
        <meta name="article:modified_time" content={dateModified} />
      )}
      {/* // TODO: line below content prop need clarify */}
      <meta name="copyright" content="Luxexpress" />

      {existingSlugs.map(([l, slug]) => {
        const isDefault = l === defaultLocale;

        let link = type
          ? `${NEXT_PUBLIC_DOMAIN}/${isDefault ? "" : `${l}/`}${type}/${slug}/`
          : `${NEXT_PUBLIC_DOMAIN}${isDefault ? "" : `/${l}`}${isHome ? "/" : asPath}`;

        return l === defaultLocale ? (
          <Fragment key={l}>
            <link rel="alternate" hrefLang="x-default" href={link} />
            <link rel="alternate" hrefLang={l} href={link} />
          </Fragment>
        ) : (
          <link key={l} rel="alternate" hrefLang={l} href={link} />
        );
      })}
    </Head>
  );
};

export default HeadSeo;
